import ZiruiImage from "../../assets/2026/team/zirui.webp";
import YoungkyuImage from "../../assets/2026/team/youngkyu.webp";
import JayeImage from "../../assets/2026/team/jaye.webp";
import LisaImage from "../../assets/2026/team/lisa.webp";
import ShaniceImage from "../../assets/2026/team/shanice.webp";
import HewieImage from "../../assets/2026/team/hewie.webp";
import ElizaImage from "../../assets/2026/team/eliza.webp";
import KelvinImage from "../../assets/2026/team/kelvin.webp";
import DesmondImage from "../../assets/2025/team/desmond.webp";
import HafsahImage from "../../assets/2025/team/hafsah.webp";

const teamMembers = [
  {
    name: "Bai Zirui",
    position: "Chair",
    image: ZiruiImage,
  },
  {
    name: "Jeong Youngkyu",
    position: "Chair",
    image: YoungkyuImage,
  },
  {
    name: "Yeo Jaye Lin",
    position: "Programmes Head",
    image: JayeImage,
  },
  {
    name: "Lisa Lim Yu Qi",
    position: "Programmes Head",
    image: LisaImage,
  },
  {
    name: "Zhuang Ying'En Shanice",
    position: "Publicity Head",
    image: ShaniceImage,
  },
  {
    name: "Tan Hewie",
    position: "Logistics Head",
    image: HewieImage,
  },
  {
    name: "Eliza Lim Siew Ping",
    position: "Logistics Head",
    image: ElizaImage,
  },
  {
    name: "Kelvin Lee",
    position: "Staff Advisor",
    image: KelvinImage,
  },
  {
    name: "Desmond Ng",
    position: "Staff Advisor",
    image: DesmondImage,
  },
  {
    name: "Hafsah Begum",
    position: "Staff Advisor",
    image: HafsahImage,
  },
];

export default teamMembers;
